var GrouponSDS;

require('./sds_common.coffee');

GrouponSDS = (function() {
  var alt_focus_input_id, dlg_id, focus_input_id;

  dlg_id = '#sub_dlg';

  focus_input_id = '#email_id';

  alt_focus_input_id = '#email';

  function GrouponSDS() {
    var ref, showContainer, showSubsUI;
    if ((ref = window.SubscriptionsUI) != null ? typeof ref._should_show_doi === "function" ? ref._should_show_doi() : void 0 : void 0) {
      $('#global-container').show();
      return;
    }
    if (this.shouldHideUI()) {
      $('#global-container').show();
    } else {
      showSubsUI = (function(_this) {
        return function() {
          GrouponSDSCommon.setupSuccessCallback();
          return _this.showModal();
        };
      })(this);
      showContainer = function() {
        return $('#global-container').show();
      };
      GrouponSDSCommon.fpBasedShow(showSubsUI, showContainer);
    }
  }

  GrouponSDS.prototype.shouldHideUI = function() {
    var hideUI, subForced;
    subForced = GrouponSDSCommon.isSubForced();
    hideUI = !subForced && !GrouponSDSCommon.isNAQTraffic() && (GrouponSDSCommon.isEmailClickTraffic() || GrouponSDSCommon.isMobileSeoSkippingTraffic());
    if (hideUI) {
      GrouponSDSCommon.log("subscriptionUINotShown", {
        "uiType": "modal-dialog"
      });
    } else if (subForced) {
      GrouponSDSCommon.log("subscriptionUIForced");
    }
    return hideUI;
  };

  GrouponSDS.prototype.showModal = function() {
    var $container, $dlg, dlg_height, dlg_width, height, now, overlayColor;
    $('#global-container').show();
    $container = $('#subscribe_modal_container');
    $dlg = $(dlg_id);
    if (!$dlg.hasClass('centered')) {
      dlg_width = $container.width();
      dlg_height = $container.height();
      $container.css({
        'top': '50%',
        'left': '50%',
        'height': dlg_height,
        'width': dlg_width,
        'margin-top': -dlg_height / 2,
        'margin-left': -dlg_width / 2
      });
    }
    $container.show();
    if ($dlg.hasClass('round')) {
      height = Math.round($dlg[0].scrollHeight);
      if (height > $dlg.height()) {
        $dlg.width(height).height(height);
      }
    }
    overlayColor = window._subscriptionOverlayColor != null ? window._subscriptionOverlayColor : "#333";
    if (typeof $container.spotlight === "function") {
      $container.spotlight({
        opacity: 0.7,
        color: overlayColor,
        exitEvent: "none"
      });
    }
    if ($(focus_input_id).length > 0) {
      $(focus_input_id).focus();
    } else if ($(alt_focus_input_id).length > 0) {
      $(alt_focus_input_id).focus();
    }
    GrouponSDSCommon.gtmSubscribeLandingEvent();
    now = new Date();
    window._subsUIshown = {
      uiType: "modal-dialog",
      time: now.getTime()
    };
    $dlg.on("dismiss", function() {
      GrouponSDSCommon.dismissModal($container);
      return GrouponSDSCommon.log("subscriptionUIHidden", {
        "uiType": "modal-dialog"
      });
    });
    $dlg.on("fail", function() {
      return GrouponSDSCommon.dismissModal($container);
    });
    $dlg.on("success", function() {
      var ref, ref1;
      GrouponSDSCommon.dismissModal($container);
      if (window._subscriptionSuccessCallback == null) {
        GrouponSDSCommon.showSuccessNotification();
        GrouponSDSCommon.gtmSubscribeEvent();
      }
      if ((ref = window.SubscriptionsUI) != null ? ref._should_show_doi() : void 0) {
        return (ref1 = window.SubscriptionsUI) != null ? ref1._get_doi_modal_and_show('#333') : void 0;
      }
    });
    return $dlg.on("close", function() {
      GrouponSDSCommon.dismissModal($container);
      if (typeof Cookie !== "undefined" && Cookie !== null) {
        Cookie.set("hide_sub_modal", 1, null, $('head').data('domain'));
      }
      return GrouponSDSCommon.log("subscriptionUIHidden", {
        "uiType": "modal-dialog"
      });
    });
  };

  return GrouponSDS;

})();

window.GrouponSDS = GrouponSDS;

window.SDSinit = new GrouponSDS();

//# sourceMappingURL=data:application/json;base64,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
